var GrouponSDS;

require('./sds_common.coffee');

GrouponSDS = (function() {
  var alt_focus_input_id, dlg_id, focus_input_id;

  dlg_id = '#sub_dlg';

  focus_input_id = '#email_id';

  alt_focus_input_id = '#email';

  function GrouponSDS() {
    var ref, showContainer, showSubsUI;
    if ((ref = window.SubscriptionsUI) != null ? typeof ref._should_show_doi === "function" ? ref._should_show_doi() : void 0 : void 0) {
      $('#global-container').show();
      return;
    }
    if (this.shouldHideUI()) {
      $('#global-container').show();
    } else {
      showSubsUI = (function(_this) {
        return function() {
          GrouponSDSCommon.setupSuccessCallback();
          return _this.showModal();
        };
      })(this);
      showContainer = function() {
        return $('#global-container').show();
      };
      GrouponSDSCommon.fpBasedShow(showSubsUI, showContainer);
    }
  }

  GrouponSDS.prototype.shouldHideUI = function() {
    var hideUI, subForced;
    subForced = GrouponSDSCommon.isSubForced();
    hideUI = !subForced && !GrouponSDSCommon.isNAQTraffic() && (GrouponSDSCommon.isEmailClickTraffic() || GrouponSDSCommon.isMobileSeoSkippingTraffic());
    if (hideUI) {
      GrouponSDSCommon.log("subscriptionUINotShown", {
        "uiType": "modal-dialog"
      });
    } else if (subForced) {
      GrouponSDSCommon.log("subscriptionUIForced");
    }
    return hideUI;
  };

  GrouponSDS.prototype.showModal = function() {
    var $container, $dlg, dlg_height, dlg_width, height, now, overlayColor;
    $('#global-container').show();
    $container = $('#subscribe_modal_container');
    $dlg = $(dlg_id);
    if (!$dlg.hasClass('centered')) {
      dlg_width = $container.width();
      dlg_height = $container.height();
      $container.css({
        'top': '50%',
        'left': '50%',
        'height': dlg_height,
        'width': dlg_width,
        'margin-top': -dlg_height / 2,
        'margin-left': -dlg_width / 2
      });
    }
    $container.show();
    if ($dlg.hasClass('round')) {
      height = Math.round($dlg[0].scrollHeight);
      if (height > $dlg.height()) {
        $dlg.width(height).height(height);
      }
    }
    overlayColor = window._subscriptionOverlayColor != null ? window._subscriptionOverlayColor : "#333";
    if (typeof $container.spotlight === "function") {
      $container.spotlight({
        opacity: 0.7,
        color: overlayColor,
        exitEvent: "none"
      });
    }
    if ($(focus_input_id).length > 0) {
      $(focus_input_id).focus();
    } else if ($(alt_focus_input_id).length > 0) {
      $(alt_focus_input_id).focus();
    }
    GrouponSDSCommon.gtmSubscribeLandingEvent();
    now = new Date();
    window._subsUIshown = {
      uiType: "modal-dialog",
      time: now.getTime()
    };
    $dlg.on("dismiss", function() {
      GrouponSDSCommon.dismissModal($container);
      return GrouponSDSCommon.log("subscriptionUIHidden", {
        "uiType": "modal-dialog"
      });
    });
    $dlg.on("fail", function() {
      return GrouponSDSCommon.dismissModal($container);
    });
    $dlg.on("success", function() {
      var ref, ref1;
      GrouponSDSCommon.dismissModal($container);
      if (window._subscriptionSuccessCallback == null) {
        GrouponSDSCommon.showSuccessNotification();
        GrouponSDSCommon.gtmSubscribeEvent();
      }
      if ((ref = window.SubscriptionsUI) != null ? ref._should_show_doi() : void 0) {
        return (ref1 = window.SubscriptionsUI) != null ? ref1._get_doi_modal_and_show('#333') : void 0;
      }
    });
    return $dlg.on("close", function() {
      GrouponSDSCommon.dismissModal($container);
      if (typeof Cookie !== "undefined" && Cookie !== null) {
        Cookie.set("hide_sub_modal", 1, null, $('head').data('domain'));
      }
      return GrouponSDSCommon.log("subscriptionUIHidden", {
        "uiType": "modal-dialog"
      });
    });
  };

  return GrouponSDS;

})();

window.GrouponSDS = GrouponSDS;

window.SDSinit = new GrouponSDS();

//# sourceMappingURL=data:application/json;base64,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
